import React from "react";
import { Button } from "../../atoms/button";
import { DrawerSectionTitle } from "../../atoms/drawerSectionTitle";
import { Text } from "../../../atomic-components/atoms/text";
import { If } from "../../atoms/if";
import changeAmountIcon from "../../../images/deposit/change_amount.svg";

import {
  StyledAccountDetails,
  StyledAccountDetailLine,
  StyledAmountChange,
  StyledToAccount,
  StyledWithdrawAmount,
  StyledWithdrawAmountValue,
} from "../../organisms/WithdrawDrawer/style";
import { formatCurrency } from "../../../utils/currencyFormatting";
import { useTranslation } from "@repo/translation";

export const WithdrawStepReview = ({
  isLoading,
  isMobile,
  isSubmitDisabled,
  availableBalance,
  currencySymbol,
  selectedBank,
  withdrawAmount,
  onAmountChangeClick,
}) => {
  const { translate } = useTranslation();

  return (
    <>
      <section>
        <DrawerSectionTitle
          title={translate("payments.withdraw.withdrawing")}
        />
        <StyledWithdrawAmount>
          <StyledWithdrawAmountValue>
            {currencySymbol} {formatCurrency(withdrawAmount)}
          </StyledWithdrawAmountValue>
          <If
            condition={isMobile}
            render={() => (
              <StyledAmountChange onClick={onAmountChangeClick}>
                <img src={changeAmountIcon} alt="Change amount Icon" />
                <span>{translate("payments.deposit.changeButton")}</span>
              </StyledAmountChange>
            )}
          />
        </StyledWithdrawAmount>

        <StyledToAccount>
          <Text>{translate("payments.withdraw.to")} </Text>
          <Text bold>{selectedBank?.bank?.name}</Text>
        </StyledToAccount>

        <If
          condition={!isMobile}
          render={() => (
            <StyledAmountChange onClick={onAmountChangeClick}>
              <img src={changeAmountIcon} alt="Change amount Icon" />
              <span>{translate("payments.deposit.changeButton")}</span>
            </StyledAmountChange>
          )}
        />

        <StyledAccountDetails>
          <StyledAccountDetailLine>
            <span>{translate("payments.withdraw.branch")}:</span>
            <span>{selectedBank?.bankBranch}</span>
          </StyledAccountDetailLine>
          <StyledAccountDetailLine>
            <span>{translate("payments.withdraw.checkingAccount")}:</span>
            <span>{selectedBank?.accountNumber}</span>
          </StyledAccountDetailLine>
          <StyledAccountDetailLine>
            <span>{translate("payments.withdraw.date")}:</span>
            <span>{new Date().toLocaleDateString("pt-BR")}</span>
          </StyledAccountDetailLine>
          <StyledAccountDetailLine>
            <span>
              {translate("payments.withdraw.balanceBeforeWithdrawal")}:
            </span>
            <span>
              {currencySymbol} {availableBalance}
            </span>
          </StyledAccountDetailLine>
        </StyledAccountDetails>
      </section>

      <Button
        expand
        disabled={isSubmitDisabled}
        id="btnWithdrawalModal"
        className="btn-cta"
        loading={isLoading}
      >
        {translate("payments.withdraw.withdraw")}
      </Button>
    </>
  );
};
